import React from 'react';

import { Tag, Row, Col, Popover, Button, Card } from 'antd';
//import moment from 'moment-timezone';
import Command from '../../model/Command';

import format from 'xml-formatter';
import './CommandView.css';
import MediaQuery from 'react-responsive';
import {useTranslation} from "@nic-react-i18n/core";
import dayjs from 'dayjs';

interface CommandProps {
    command: Command;
    style: object;
}
/*
type StateType = {
    showRequest: boolean;
    showResponse: boolean;
    xmlRequest: React.ReactElement<any>;
    xmlResponse: string;
};
*/
type CommandViewProps = CommandProps

interface CommandViewHeaderProps {
    width: number;
    size: string;
}

interface ColValues {
    lg: number;
    md: number;
    sm?: number;
    xs?: number;
}

interface CommandColumns {
    sequence: ColValues;
    status: ColValues;
    command: ColValues;
    schedule: ColValues;
    request: ColValues;
    code: ColValues;
    reasonCode: ColValues;
    reasonMessage: ColValues;
    transactionId?: ColValues;
}

const LARGE_SETTINGS: CommandColumns = {
    sequence: {lg: 1, md: 1},
    status: {lg: 1, md: 1},
    command: {lg: 4, md: 2},
    schedule: {lg: 2, md: 2},
    request: {lg: 2, md: 2},
    code: {lg: 2, md: 2},
    reasonCode: {lg: 2, md: 2},
    reasonMessage: {lg: 4, md: 4},
    transactionId: {lg: 6, md: 6},
};

const MEDIUM_SETTINGS: CommandColumns = {
    sequence: {lg: 2, md: 2, sm: 2, xs: 2},
    status: {lg: 2, md: 2, sm: 2, xs: 2},
    command: {lg: 4, md: 4, sm: 2, xs: 2},
    schedule: {lg: 4, md: 4, sm: 4, xs: 4},
    request: {lg: 4, md: 4, sm: 4, xs: 4},
    code: {lg: 2, md: 2, sm: 2, xs: 4},
    reasonCode: {lg: 2, md: 2, sm: 2, xs: 2},
    reasonMessage: {lg: 4, md: 4, sm: 4, xs: 2},
};

export const CommandViewHeader: React.FC<CommandViewHeaderProps> = (props) => {
    const {t} = useTranslation()
    const renderHeaderLargeMediumDisplay = (colValues: CommandColumns, renderTransactionId: boolean) => {


        return (
            <Row>
                <Col
                    md={colValues.sequence.md}
                    lg={colValues.sequence.lg}
                    sm={colValues.sequence.sm}
                    xs={colValues.sequence.xs}
                    className={'test-header'}
                >
                    <span>{t('test.header.sequence')}</span>
                </Col>
                <Col
                    lg={colValues.status.lg}
                    md={colValues.status.md}
                    sm={colValues.status.sm}
                    xs={colValues.status.xs}
                    style={{paddingLeft: '15px'}}
                    className={'test-header'}
                >
                    <span >{t('test.header.status')}</span>
                </Col>

                <Col
                    lg={colValues.command.lg}
                    md={colValues.command.md}
                    sm={colValues.command.sm}
                    xs={colValues.command.xs}
                    className={'test-header'}
                >
                    <span >{t('test.header.command')}</span>
                </Col>

                <Col
                    lg={colValues.schedule.lg}
                    md={colValues.schedule.md}
                    sm={colValues.schedule.sm}
                    xs={colValues.schedule.xs}
                    className={'test-header'}
                >
                    <span>{t('test.header.schedule')}</span>
                </Col>

                <Col
                    lg={colValues.request.lg}
                    md={colValues.request.md}
                    sm={colValues.request.sm}
                    xs={colValues.request.xs}
                    className={'test-header'}
                >
                    <span >{t('test.header.request')}</span>
                </Col>

                <Col
                    lg={colValues.code.lg}
                    md={colValues.code.md}
                    sm={colValues.code.sm}
                    xs={colValues.code.xs}
                    className={'test-header'}
                >
                    <span >{t('test.header.code')}</span>
                </Col>

                <Col
                    lg={colValues.reasonCode.lg}
                    md={colValues.reasonCode.md}
                    sm={colValues.reasonCode.sm}
                    xs={colValues.reasonCode.xs}
                    className={'test-header'}
                >
                    <span >{t('test.header.reasonCode')}</span>
                </Col>

                <Col
                    lg={colValues.reasonMessage.lg}
                    md={colValues.reasonMessage.md}
                    sm={colValues.reasonMessage.sm}
                    xs={colValues.reasonMessage.xs}
                    className={'test-header'}
                >
                    <span >{t('test.header.reasonMessage')}</span>
                </Col>
                {renderTransactionId && colValues.transactionId &&
                <Col lg={colValues.transactionId.lg} md={colValues.transactionId.md} className={'test-header'}>
                    <span>{t('test.header.transactionId')}</span>
                </Col>
                }
            </Row>
        );
    }

    const renderHeaderSmallDisplay = () => {

        return (
            <div
                style={{
                    width: '95%',
                    display: 'flex',
                    justifyContent: 'space-around'
                }}
            >
                <div
                    className={'test-header-small'}
                >
                    <span>{t('test.header.sequence')}</span>
                </div>
                <div
                    style={{paddingTop: '10px'}}
                    className={'test-header-small'}
                >
                    <span >{t('test.header.status')}</span>
                </div>

                <div
                    style={{paddingTop: '20px'}}
                    className={'test-header-small'}
                >
                    <span >{t('test.header.command')}</span>
                </div>

                <div
                    className={'test-header-small'}
                >
                    <span>{t('test.header.schedule')}</span>
                </div>

                <div
                    style={{marginBottom: '10px'}}
                    className={'test-header-small'}
                >
                    <span >{t('test.header.request')}</span>
                </div>

                <div
                    className={'test-header-small'}
                >
                    <span >{t('test.header.code')}</span>
                </div>

                <div
                    className={'test-header-small'}
                >
                    <span >{t('test.header.reasonCode')}</span>
                </div>

                <div
                    className={'test-header-small'}
                >
                    <span >{t('test.header.reasonMessage')}</span>
                </div>
            </div>
        );
    }

        const {width, size} = props;
        let renderTransactionId: boolean = true;
        let header;

        let colValues: CommandColumns = LARGE_SETTINGS;
        if (size === 'medium')  {
            renderTransactionId = false;
            colValues = MEDIUM_SETTINGS;
        }

        if (size === 'small') {
            header = renderHeaderSmallDisplay();
        } else {
            header = renderHeaderLargeMediumDisplay(colValues, renderTransactionId);
        }

        return (
            <div style={{width: width}}>
                {header}
            </div>
        );

}

export const CommandView: React.FC<CommandViewProps> = (props) => {

//    const [showRequest, setShowRequest] = React.useState(false)
    //const [showResponse, setShowResponse] = React.useState(false)
    const [xmlRequest, setXmlRequest] = React.useState(<span/>)
    //const [xmlResponse, setXmlResponse] = React.useState('')
    const {t} = useTranslation()
    const renderMediumDisplay = () => {

        const {command, style} = props;

        const date = dayjs(command.request.date);

        let rowStyle = {

            paddingTop: '10px',
            // borderTop: '1px dashed #e9e9e9',
            borderBottom: '1px dashed #e9e9e9'
        };

        let combined = {...style, ...rowStyle};

        return (

            <Row
                style={combined}
            >
                <Col
                    lg={MEDIUM_SETTINGS.sequence.lg}
                    md={MEDIUM_SETTINGS.sequence.md}
                    sm={MEDIUM_SETTINGS.sequence.sm}
                    xs={MEDIUM_SETTINGS.sequence.xs}
                    className={'test-data'}
                >
                    <span>{command.sequence ? command.sequence : '-'}</span>
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.status.lg}
                    md={MEDIUM_SETTINGS.status.md}
                    sm={MEDIUM_SETTINGS.status.sm}
                    xs={MEDIUM_SETTINGS.status.xs}
                    className={'test-data'}
                >
                    {command.sequence ?
                        <i className={'green fal fa-check-circle'}/> :
                        <i className={'red fal fa-times-circle'} />}
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.command.lg}
                    md={MEDIUM_SETTINGS.command.md}
                    sm={MEDIUM_SETTINGS.command.sm}
                    xs={MEDIUM_SETTINGS.command.xs}
                    className={'test-data'}
                >
                    <Popover
                        content={command.request.commandType}
                        title={t('test.header.command')}
                    >
                        <div style={{cursor: 'pointer'}}><i className={'fal fa-code'}/></div>
                    </Popover>
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.schedule.lg}
                    md={MEDIUM_SETTINGS.schedule.md}
                    sm={MEDIUM_SETTINGS.schedule.sm}
                    xs={MEDIUM_SETTINGS.schedule.xs}
                    className={'test-data'}
                >
                    <span>
                        <Tag style={{cursor: 'default'}}>
                            <i className={'fal fa-clock'}/>
                            <span style={{paddingLeft: '10px'}}>{date.format('HH:mm:ss')}</span>
                        </Tag>
                    </span>
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.request.lg}
                    md={MEDIUM_SETTINGS.request.md}
                    sm={MEDIUM_SETTINGS.request.sm}
                    xs={MEDIUM_SETTINGS.request.xs}
                    className={'test-data'}
                >
                    <Popover content={xmlRequest} title="Request" trigger="click">
                        <Button
                            size={'small'}
                            onClick={() => { formatXML(); }}
                        >
                            Request
                        </Button>
                    </Popover>
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.code.lg}
                    md={MEDIUM_SETTINGS.code.md}
                    sm={MEDIUM_SETTINGS.code.sm}
                    xs={MEDIUM_SETTINGS.code.xs}
                    className={'test-data'}
                >
                    {command.response.code}
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.reasonCode.lg}
                    md={MEDIUM_SETTINGS.reasonCode.md}
                    sm={MEDIUM_SETTINGS.reasonCode.sm}
                    xs={MEDIUM_SETTINGS.reasonCode.xs}
                    className={'test-data'}
                >
                    {command.response.reason}
                </Col>

                <Col
                    lg={MEDIUM_SETTINGS.reasonMessage.lg}
                    md={MEDIUM_SETTINGS.reasonMessage.md}
                    sm={MEDIUM_SETTINGS.reasonMessage.sm}
                    xs={MEDIUM_SETTINGS.reasonMessage.xs}
                    className={'test-data'}
                >
                    {
                        command.response.reason && !command.sequence &&
                        <Popover content={command.response.reasonMessage} title="Reason Message" trigger="click">
                            <Button size={'small'}>Reason Message</Button>
                        </Popover>
                    }
                </Col>

            </Row>
        );

    }

    const renderSmallDisplay = () => {

        const {command, style} = props;

        const date = dayjs(command.request.date);

        let rowStyle = {
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            paddingTop: '10px',
            // borderTop: '1px dashed #e9e9e9',
            borderBottom: '1px dashed #e9e9e9'
        };

        let combined = {...style, ...rowStyle};

        return (

            <div
                style={combined}
            >
                <div
                    className={'test-data'}
                >
                    <span>{command.sequence ? command.sequence : '-'}</span>
                </div>

                <div
                    className={'test-data'}
                >
                    {command.sequence ?
                        <i className={'green fal fa-check-circle'}/> :
                        <i className={'red fal fa-times-circle'} />}
                </div>

                <div
                    className={'test-data'}
                >
                    <Popover
                        content={command.request.commandType}
                        title={t('test.header.command')}
                    >
                        <div style={{cursor: 'pointer'}}><i className={'fal fa-code'}/></div>
                    </Popover>
                </div>

                <div
                    className={'test-data'}
                >
                    <span>
                        <Tag style={{cursor: 'default'}}>
                            <i className={'fal fa-clock'}/>
                            <span style={{paddingLeft: '10px'}}>{date.format('HH:mm:ss')}</span>
                        </Tag>
                    </span>
                </div>

                <div
                    className={'test-data'}
                >
                    <Popover content={xmlRequest} title="Request" trigger="click">
                        <Button
                            size={'small'}
                            onClick={() => { formatXML(); }}
                        >
                            Request
                        </Button>
                    </Popover>
                </div>

                <div
                    className={'test-data'}
                >
                    {command.response.code}
                </div>

                <div
                    className={'test-data'}
                >
                    {command.response.reason}
                </div>

                <div
                    className={'test-data'}
                >
                    {
                        command.response.reason && !command.sequence &&
                        <Popover content={command.response.reasonMessage} title="Reason Message" trigger="click">
                            <Button size={'small'}>Reason Message</Button>
                        </Popover>
                    }
                </div>

            </div>
        );

    }

    const renderLargeDisplay = () => {

        const {command, style} = props;

        const date = dayjs(command.request.date);

        let rowStyle = {

            paddingTop: '10px',
            // borderTop: '1px dashed #e9e9e9',
            borderBottom: '1px dashed #e9e9e9'
        };
        /*
                let preStyle = {
                    height: 'auto',
                    maxHeight: '200px',
                    overflow: 'auto',
                    wordBreak: 'normal !important',
                    wordWrap: 'normal !important',
                    whiteSpace: 'pre !important',
                    fontSize: '9px',
                };
        */
        let combined = {...style, ...rowStyle};

        return (

            <Row
                style={combined}
            >
                <Col lg={1} md={1}  className={'test-data'}>
                    <span>{command.sequence ? command.sequence : '-'}</span>
                </Col>
                <Col lg={1} md={1}  className={'test-data'}>
                    {command.sequence ?
                        <i className={'green fal fa-check-circle'}/> :
                        <i className={'red fal fa-times-circle'} />}
                </Col>

                <Col lg={4} md={4} className={'test-data'}>
                    <span>{command.request.commandType}</span>
                </Col>

                <Col lg={2}  md={2} className={'test-data'}>
                    <span>
                        <Tag style={{cursor: 'default'}}>
                            <i className={'fal fa-clock'}/>
                            <span style={{paddingLeft: '10px'}}>{date.format('HH:mm:ss')}</span>
                        </Tag>
                    </span>
                </Col>

                <Col lg={2}  md={2} className={'test-data'}>
                    <Popover content={xmlRequest} title="Request" trigger="click">
                        <Button
                            size={'small'}
                            onClick={() => { formatXML(); }}
                        >
                            Request
                        </Button>
                    </Popover>
                </Col>

                <Col lg={2}  md={2} className={'test-data'}>
                    {command.response.code}
                </Col>

                <Col lg={2}  md={2} className={'test-data'}>
                    {command.response.reason}
                </Col>

                <Col lg={4}  md={4} className={'test-data'}>
                    {
                        command.response.reason && !command.sequence &&
                        <Popover content={command.response.reasonMessage} title="Reason Message" trigger="click">
                            <Button size={'small'}>Reason Message</Button>
                        </Popover>
                    }
                </Col>

                <Col lg={6}  md={6} className={'test-data'}>
                    <Popover
                        content={command.response.serverTransactionId ? command.response.serverTransactionId : '-'}
                        title={'Server Transaction Id'}
                        trigger={'click'}
                    >
                        <div style={{cursor: 'pointer'}}><i className={'fal fa-info-circle'}/></div>
                    </Popover>
                </Col>

            </Row>
        );
    }

    const formatXML = () => {
        const {command} = props;
        let formXML;
        let xmlStripped2 = command.request.request.replace(/\s{2,}/g, ' ');

        let className = 'xml-view';

        try {
            let xmlStripped = xmlStripped2.replace(/\s+(?=[^[>]*<)/g, '');
            formXML = format(xmlStripped);
        } catch (e) {
            className = 'xml-view-error';
            formXML = xmlStripped2.replace(/(><)/g, '>\n<');
        }

        const formattedXML = (
            <Card>
                <pre
                    className={className}
                >
                    {formXML}
                </pre>
            </Card>
        );
        setXmlRequest(formattedXML)
    }


        return (
            <span>
                <MediaQuery minWidth={1200}>
                    {renderLargeDisplay()}
                </MediaQuery>
                <MediaQuery minWidth={600} maxWidth={1199}>
                    {renderMediumDisplay()}
                </MediaQuery>

                <MediaQuery minWidth={300} maxWidth={599}>
                    {renderSmallDisplay()}
                </MediaQuery>
            </span>
        );

}
export default CommandView